var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "has-background-dark tile-border" },
    [
      _c(
        "DashboardPanel",
        [
          _c(
            "div",
            {
              staticClass:
                "panel-heading has-text-centered has-text-white custom-panel-heading",
            },
            [_vm._v(" INSURER MESSAGES ")]
          ),
          _c("DashboardProgressBar", {
            attrs: {
              "is-loading": _vm.isLoading,
              "initial-color": "#fff",
              "loading-color": "#d90951",
            },
          }),
          _c(
            "div",
            { staticClass: "has-background-dark tile-border" },
            [
              _vm.pnet
                ? _c("DashboardPnet", {
                    staticClass: "custom-panel-border",
                    attrs: {
                      pnet: _vm.pnet,
                      "is-uninvoiced-jobs-and-chart-disabled":
                        _vm.isUninvoicedJobsAndChartDisabled,
                    },
                  })
                : _vm._e(),
              _vm.orm
                ? _c("DashboardOrm", {
                    staticClass: "custom-panel-border",
                    attrs: {
                      orm: _vm.orm,
                      "is-uninvoiced-jobs-and-chart-disabled":
                        _vm.isUninvoicedJobsAndChartDisabled,
                    },
                  })
                : _vm._e(),
              _vm.estimage
                ? _c("DashboardEstimage", {
                    staticClass: "custom-panel-border",
                    attrs: {
                      estimage: _vm.estimage,
                      "is-uninvoiced-jobs-and-chart-disabled":
                        _vm.isUninvoicedJobsAndChartDisabled,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }